import { MenuIcon } from "components/AppHeader/Mobile/MobileHeader";
import { setAppBackdrop } from "features/appBackdrop/appBackdropSlice";
import { selectIsToggled } from "features/drawer/drawerSlice";
import React, { useCallback, useEffect, useState, memo } from "react";
import { MdSearch } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import MobileSearchResult from "./MobileSearchResult";
import { setSearchedProducts } from "./searchSlice";

const MobileSearch: React.FC = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const isDrawerToggled = useSelector(selectIsToggled);
  const dispatch = useDispatch();
  const handleClick = useCallback(
    (e: any) => {
      e.preventDefault();
      setShow(!show);
      dispatch(setAppBackdrop(!show));
      dispatch(setSearchedProducts([]));
    },
    [show]
  );

  useEffect(() => {
    setShow(false);
    dispatch(setAppBackdrop(false));
  }, [location]);

  useEffect(() => {
    isDrawerToggled && setShow(false);
  }, [isDrawerToggled]);
  return (
    <MobileSearchContainer>
      <MenuIcon onClick={handleClick}>
        <MdSearch color="white" size="2em" />
      </MenuIcon>
      {show && <MobileSearchResult onClick={handleClick} />}
    </MobileSearchContainer>
  );
};

const MobileSearchContainer = styled.div``;

export default memo(MobileSearch);
